// import { loadStripe } from '@stripe/stripe-js';
import { SUBSCRIPTION_PLANS } from 'constants/subscriptions';
import { createSubscribeCheckout } from '../reducers/subscriptionReducer';
import { SubscriptionHelper } from 'view/helpers';

/* The line `// import { loadStripe } from '@stripe/stripe-js';` is a commented-out import statement in
JavaScript. It seems like the original code was attempting to import the `loadStripe` function from
the `@stripe/stripe-js` library, which is used for working with Stripe in JavaScript applications. */
// // Initialize Stripe - replace with your publishable key
// const stripePromise = loadStripe(
// 	'pk_test_51RpxCxGRB8wHY2n3IVrQa4ULys2YhFtRtaGxRSfZg5cy94gg4u9v5MOS1nnUunmWvprbhlxzOxnqR2BrkY22gVsR00eM3ld0f2'
// );

// /**
//  * Creates a Stripe checkout session directly with Stripe
//  */
// export const createCheckoutSession =
// 	(priceId, planName, billingInterval) => async (dispatch, getState) => {
// 		const state = getState();
// 		dispatch(createCheckoutRequest());

// 		try {
// 			const stripe = await stripePromise;
// 			const { userData } = state.user;

// 			console.log('🔍 Creating Stripe checkout session with:', {
// 				priceId,
// 				planName,
// 				billingInterval,
// 				customerEmail: userData?.email,
// 			});

// 			// Create checkout session directly with Stripe
// 			// Use customer ID if available, otherwise use email (which will create new customer)
// 			const checkoutParams = {
// 				lineItems: [
// 					{
// 						price: priceId,
// 						quantity: 1,
// 					},
// 				],
// 				mode: 'subscription',
// 				successUrl: `${window.location.origin}/payment-success?session_id={CHECKOUT_SESSION_ID}`,
// 				cancelUrl: `${window.location.origin}/`,
// 			};

// 			// If user has a stripe_customer_id, use it; otherwise use email
// 			if (userData?.stripe_customer_id) {
// 				console.log(
// 					'✅ Using existing Stripe customer ID:',
// 					userData.stripe_customer_id
// 				);
// 				checkoutParams.customer = userData.stripe_customer_id;
// 			} else {
// 				console.log(
// 					'⚠️ Using email - will create new customer:',
// 					userData?.email
// 				);
// 				checkoutParams.customerEmail = userData?.email;
// 			}

// 			const { error } = await stripe.redirectToCheckout(checkoutParams);

// 			if (error) {
// 				console.error('❌ Stripe checkout error:', error);
// 				dispatch(createCheckoutError(error));
// 				throw error;
// 			} else {
// 				console.log('✅ Redirecting to Stripe checkout...');
// 				dispatch(createCheckoutSuccess({ redirected: true }));
// 				// The redirect happens automatically, so we don't return anything
// 			}
// 		} catch (error) {
// 			console.error('💥 Checkout session creation failed:', error);
// 			dispatch(createCheckoutError(error));
// 			throw error;
// 		}
// 	};

// /**
//  * Redirects to Stripe checkout
//  */
// export const redirectToCheckout = async (sessionId) => {
// 	const stripe = await stripePromise;
// 	const { error } = await stripe.redirectToCheckout({
// 		sessionId: sessionId,
// 	});

// 	if (error) {
// 		console.error('Stripe redirect error:', error);
// 		throw error;
// 	}
// };

/**
 * Fallback pricing data structure (matches current static data but with Stripe IDs)
 * This will be used if Stripe API calls fail
 */
export const getFallbackPricingData = () => {
	return SubscriptionHelper.getFallbackPricingData();
};

/**
 * Creates a subscribe checkout session via backend API
 * @param {string} planId - The plan ID to subscribe to
 * @returns {function} Redux thunk
 */
export const subscribeCheckout = (planId) => {
	return createSubscribeCheckout(planId);
};

/**
 * Helper function to find plan by ID from fallback data
 * @param {string} planId - The plan ID to find
 * @returns {object|null} The plan object or null if not found
 */
export const findPlanById = (planId) => {
	const plans = getFallbackPricingData();
	return plans.find((plan) => plan.id === planId) || null;
};

/**
 * Helper function to get next higher tier plan
 * @param {string} currentPlanId - Current plan ID
 * @returns {object|null} Next tier plan or null if already at highest
 */
export const getUpgradePlan = (currentPlanId) => {
	const currentPlan = findPlanById(currentPlanId);
	if (!currentPlan) return null;

	const planOrder = [
		SUBSCRIPTION_PLANS.FREE,
		SUBSCRIPTION_PLANS.STARTER,
		SUBSCRIPTION_PLANS.PRO,
		SUBSCRIPTION_PLANS.BUSINESS,
		SUBSCRIPTION_PLANS.ENTERPRISE,
	];
	const currentIndex = planOrder.indexOf(currentPlanId);
	if (currentIndex === -1 || currentIndex >= planOrder.length - 1) return null;

	const nextPlanId = planOrder[currentIndex + 1];
	return findPlanById(nextPlanId);
};

/**
 * Helper function to get next lower tier plan
 * @param {string} currentPlanId - Current plan ID
 * @returns {object|null} Lower tier plan or null if already at lowest
 */
export const getDowngradePlan = (currentPlanId) => {
	// const plans = getFallbackPricingData();
	const currentPlan = findPlanById(currentPlanId);
	if (!currentPlan) return null;

	const planOrder = [
		SUBSCRIPTION_PLANS.FREE,
		SUBSCRIPTION_PLANS.STARTER,
		SUBSCRIPTION_PLANS.PRO,
		SUBSCRIPTION_PLANS.BUSINESS,
		SUBSCRIPTION_PLANS.ENTERPRISE,
	];
	const currentIndex = planOrder.indexOf(currentPlanId);
	if (currentIndex <= 0) return null;

	const prevPlanId = planOrder[currentIndex - 1];
	return findPlanById(prevPlanId);
};
